import {UserAvatarImg, NoUserAvatar, DefaultAvatar} from './UserAvatar.styles';

interface UserAvatarProps extends React.HTMLAttributes<HTMLImageElement>{
  image: string | undefined,
}

function UserAvatar(props: UserAvatarProps){
  const {image, ...rest} = props;

  return (
    <>
      {image ?
        <UserAvatarImg src={image} {...rest}/> :
        <NoUserAvatar>
          <DefaultAvatar className="fa-solid fa-user"/>
        </NoUserAvatar>
      }
    </>
  )
}

export default UserAvatar;
